import { gql } from "@apollo/client";

export const CREATE_COMPANY_QUERY = gql`
  mutation CreateCompany(
    $name: String!
    $internalReference: String
    $accountingFirm: ID!
    $vatNumber: String!
    $software: ID
    $ssiType: String
    $accountingPlanType: String
  ) {
    createCompany(
      input: {
        name: $name
        internalReference: $internalReference
        accountingFirm: $accountingFirm
        vatNumber: $vatNumber
        software: $software
        ssiType: $ssiType
        accountingPlanType: $accountingPlanType
      }
    ) {
      errors {
        field
        messages
      }
      company {
        id
        name
        internalReference
        currency {
          value
        }
        accountingFirm {
          id
          name
        }
        vatNumber
        businessCode
        commercialRegisterNumber
        email
        phone1
        phone2
        fax
        software {
          id
          name
          software {
            label
            value
          }
        }
        settings {
          accountingPlanType {
            value
          }
        }
        logo
      }
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_OPTIONS_SSI_TYPE = gql`
  query {
    listSsiTypeChoices {
      label
      value
    }
    listAccountingPlanTypeChoices {
      label
      value
    }
  }
`;
export const GET_CEGID_VAT_OPTIONS = gql`
  query {
    listCegidVatCodeChoices {
      label
      value
    }
    listCegidVatRegimeChoices {
      label
      value
    }
  }
`;

export const UPDATE_COMPANY_SETTINGS = gql`
  mutation updateCompanySettings($input: CompanySettingInput!) {
    updateCompanySettings(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_COMPANY = gql`
  mutation deleteCompany($id: ID!) {
    deleteCompany(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_COMPANY_QUERY = gql`
  query getCompany($id: ID!) {
    getCompany(id: $id) {
      id
      internalReference
      name
      shortName
      website
      email
      phone1
      phone2
      fax
      vatNumber
      nii: intracomVatNr
      logo
      analyticalLevel
      isTtde
    }
  }
`;

export const GET_COMPANY_LEGAL_INFO_QUERY = gql`
  query getCompanyLegalInfo($id: ID!) {
    getCompany(id: $id) {
      id
      timeLength
      capitalAmount
      vatNumber
      internalSocialReference
      nii: intracomVatNr
      rcs
      creationDate
      legalCategory {
        code
        name
      }
      legalStructure {
        code
        name
      }
      businessActivity {
        code
        name
      }
    }
  }
`;

export const GET_COMPANY_HEADER_QUERY = gql`
  query getCompanyHeader($id: ID!) {
    getCompany(id: $id) {
      id
      name
      vatNumber
      internalReference
      shortName
      accountingFirm {
        name
        id
      }
      createdAt
      updatedAt
      updatedByUser {
        email
        firstName
        lastName
      }
    }
    getCompanySettings(id: $id) {
      accountingPlanType {
        value
        label
      }
      ssiType {
        value
        label
      }
      software {
        id
        name
        software {
          label
          value
        }
        apiUrl
        importExportAuto
      }
      paPlatform {
        slug
      }
      generalAccountsLength
      allowAccountCreationsInSsi
    }
  }
`;

export const GET_COMPANY_SETTINGS = gql`
  query getCompanySettings($id: ID!) {
    getCompanySettings(id: $id) {
      ssiType {
        label
        value
      }
      software {
        id
        name
        software {
          value
        }
      }
      emailsAllowedUpload
      isAccountingFirmCompany
      accountingPlanType {
        label
        value
      }
    }
  }
`;

export const GET_CURRENT_CYCLE = gql`
  query getCurrentCycle($company: ID!) {
    getCurrentCycle(company: $company) {
      id
      startDate
      endDate
      inUse
    }
  }
`;

export const LIST_COMPANIES_PAGINATED_QUERY = gql`
  query listCompaniesPaginated(
    $filter: CompanyFilter
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listCompaniesPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        internalReference
        vatNumber
        accountingFirm {
          id
          name
        }
        settings {
          ssiType {
            value
            label
          }
          software {
            software {
              label
              value
            }
          }
          paPlatform {
            slug
          }
        }
        addresses {
          city
          postalCode
        }
        deletedAt
        deletedByUser {
          email
        }
      }
    }
  }
`;

export const LIST_LEGAL_STRUCTURES = gql`
  query listLegalStructures($search: String, $limit: Int, $offset: Int, $orderBy: [String]) {
    listLegalStructures(filter: { search: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        code
        name
      }
    }
  }
`;

export const LIST_LEGAL_CATEGORIES = gql`
  query listLegalCategories($search: String, $limit: Int, $offset: Int, $orderBy: [String]) {
    listLegalCategories(filter: { search: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        code
        name
      }
    }
  }
`;

export const LIST_BUSSINESS_ACTIVITIES = gql`
  query listBusinessActivities(
    $search: String
    $limit: Int
    $offset: Int
    $orderBy: [String]
    $countryId: ID
  ) {
    listBusinessActivities(filter: { search: $search, countryId: $countryId }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        code
        name
      }
    }
  }
`;

export const LIST_COMPANIES_FOR_SELECT = gql`
  query listCompaniesPaginated($filter: CompanyFilter, $limit: Int, $offset: Int) {
    listCompaniesPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: ["name"]) {
        id
        name
        internalReference
        logo
        accountingFirm {
          name
        }
      }
    }
  }
`;

export const GET_MAX_MIN_CYCLES = gql`
  query maxMinCyclesDates($company: ID!) {
    maxMinCyclesDates(company: $company) {
      maxEndDate
      maxLimitDate
      maxStartDate
      minEndDate
      minLimitDate
      minStartDate
    }
  }
`;

export const GET_COMPANY_WITH_ACCOUNTING_FIRM = gql`
  query getCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      internalReference
      accountingFirm {
        id
        name
      }
    }
  }
`;

export const LIST_COMPANIES_QUERY = gql`
  query listCompaniesPaginated(
    $filter: CompanyFilter
    $orderBy: [String]
    $limit: Int
    $offset: Int
  ) {
    listCompaniesPaginated(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        internalReference
      }
      totalCount
    }
  }
`;

export const UNDELETE_COMPANY = gql`
  mutation undeleteCompany($id: ID!) {
    undeleteCompany(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_ACCOUNTING_OPTIONS = gql`
  query listAccountings($filter: AccountingFilter, $offset: Int, $order: [String], $limit: Int) {
    listAccountings(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $order) {
        id
        name
        type
        code
      }
    }
  }
`;

export const GET_COMPANY_BUSINESS_ACTIVITY_QUERY = gql`
  query getCompanyBusinessActivity($id: ID!) {
    getCompany(id: $id) {
      id
      businessActivity {
        code
        name
      }
    }
  }
`;
